module.exports = __webpack_public_path__ + "img/api-explorer.d12a73e2.svg";